/**
 * reportEvent模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const reportEvent = {
  //重大事件添加
  addReportEvent(params) {
    return $http.post(`${global.API_URL}/sme/reportEvent/add`,params);
  },
  //重大事件删除
  deleteReportEvent(params) {
    return $http.post(`${global.API_URL}/sme/reportEvent/delete`,params);
  },
  //查询运维报告重大事件列表
  selectReportEventList(params) {
    return $http.post(`${global.API_URL}/sme/reportEvent/selectReportEventList`,params);
  },
  //更新
  updateReportEvent(params) {
    return $http.post(`${global.API_URL}/sme/reportEvent/update`,params);
  }
}

export default reportEvent;



// WEBPACK FOOTER //
// ./src/api/reportEvent.js